import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import makeData from '../services/makeData';
import { GENERAL } from '../config/Transaction/ProductGeneralConf';


import { COLUMNS } from '../config/Transaction/columns';
import { addAfterLoginNotification } from '../../../components/Toast/utils/notifications';

interface AsyncState {
  isLoading: {
    categoryData: boolean;
    brandsData: boolean;
    tagsData: boolean;
    categoryAdd: boolean;
    deleteCategory: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  categoryData: any;
  totalCount: Number;
  statusData: any;
  applicationOptions: any;
  addProductRes: any;
  editProductRes: any;
  deleteProductRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  brandsData: Array<any>;
  tagsData: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;
  userTableColumns: any,

}

const initialState: TableState = {
  isLoading: {
    categoryData: true,
    brandsData: true,
    tagsData: true,
    categoryAdd: false,
    deleteCategory: false,
  },
  isSuccess: false,
  isError: false,
  categoryData: null,
  statusData: null,
  applicationOptions: null,
  addProductRes: null,
  editProductRes: null,
  deleteProductRes: null,
  totalCount: NaN,
  isLogout: false,
  fullResponse: [],
  brandsData: [],
  tagsData: [],
  errorMsg: null,
  userTableColumns: COLUMNS,
};




export const fetchAllCategories = createAsyncThunk('categoryData', async (data: any, thunkAPI) => {
  try {
    const res: any = await Service.getAllCategories();

    const madeData = makeData(res.data);

    return { madeData, fullResponse: res.data };
  } catch (error: any) {
    // thunkAPI.dispatch(resetLogout(error))
    return thunkAPI.rejectWithValue(error);
  }
});


export const addCategory = createAsyncThunk('user/addProductData', async (data: any, thunkAPI) => {
  try {
    return await Service.addCategory(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});

export const deleteCategory = createAsyncThunk('user/deleteCategory', async (data: any, thunkAPI) => {
  try {
    return await Service.deleteCategory(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});


export const getColumns = createAsyncThunk('getColumns', (data: any, thunkAPI) => {
  try {
    // const madeColsData = makeData(data);
    return data?.cols;
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});


export const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchAllCategories.pending, (state, action: any) => {
        state.isLoading.categoryData = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(fetchAllCategories.fulfilled, (state, action: any) => {
        state.isLoading.categoryData = false;
        state.isSuccess = true;
        state.isError = false;
        state.categoryData = action.payload.madeData;
        state.fullResponse = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllCategories.rejected, (state, action: any) => {
        state.isLoading.categoryData = false;
        state.isError = true;
        state.errorMsg = action.payload.errorMsg;
        state = {
          ...state,
          ...action.payload
        }

      })

      .addCase(addCategory.pending, (state) => {
        state.isLoading.categoryAdd = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.addProductRes = null;
      })
      .addCase(addCategory.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Category Create successfully', "success");
        state.isLoading.categoryAdd = false;
        state.isSuccess = true;
        state.isError = false;
        state.addProductRes = action.payload;
      })
      .addCase(addCategory.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.categoryAdd = false;
        state.isSuccess = false;
        state.isError = true;
        state.addProductRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


      // MODIFY_COLUMNS
      .addCase(getColumns.pending, (state) => {
        // state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.userTableColumns = initialState.userTableColumns;
      })
      .addCase(getColumns.fulfilled, (state, action: any) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.userTableColumns = action.payload;
      })
      .addCase(getColumns.rejected, (state) => {
        // state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.userTableColumns = initialState.userTableColumns;
      })

      .addCase(deleteCategory.pending, (state) => {
        state.isLoading.deleteCategory = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.deleteProductRes = null;
      })
      .addCase(deleteCategory.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Category Deleted successfully', "success");
        state.isLoading.deleteCategory = false;
        state.isSuccess = true;
        state.isError = false;
        state.deleteProductRes = action.payload;
      })
      .addCase(deleteCategory.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.deleteCategory = false;
        state.isSuccess = false;
        state.isError = true;
        state.deleteProductRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


  },
});

export default categorySlice.reducer;
